var src,srcset,wnw_windowWidth,wnw_windowHeight,critical2,critical3,cls_css,lazyBackground,lazyIframe,lazybg,lazybg2,s,i,flag=1,external_single_loaded=1;

document.addEventListener("DOMContentLoaded", function() {
	wnw_windowWidth=screen.width;
	wnw_windowHeight=screen.height;
	lazyLoadImg2();
    lazyLoadVideo2();
	window.addEventListener("scroll", function() {
		wnw_init();
	});
	window.addEventListener("mousemove", function() {
		wnw_init();
	});
	window.addEventListener("touchstart", function() {
		wnw_init();
	});
	setTimeout(function() {
		wnw_init();
	}, 8000);
});

function wnw_init() {
	lazyLoadImg();
    lazyLoadVideo();
}

function lazyLoadImg() {
	var imgs = document.querySelectorAll("img.lazy2");

	for (i = 0; i < imgs.length; i++) {
			if (wnw_windowWidth < 600) {
				src = (imgs[i].dataset.mobsrc === undefined) ? imgs[i].dataset.src : imgs[i].dataset.mobsrc;
			} else {
				src = (imgs[i].dataset.src === undefined) ? imgs[i].src : imgs[i].dataset.src;
			}
			srcset = imgs[i].getAttribute("data-srcset") ? imgs[i].getAttribute("data-srcset") : "";
			if (src != null && src != "") {
				imgs[i].src = src;
			}
			if (srcset != null && srcset != "") {
				imgs[i].srcset = srcset;
			}
			imgs[i].classList.remove("lazy2");
	}
}

function lazyLoadVideo() {
	var vids = document.querySelectorAll("video.lazy2");

	for (i = 0; i < vids.length; i++) {
			if (wnw_windowWidth < 600) {
				src = (vids[i].dataset.mobsrc === undefined) ? vids[i].dataset.src : vids[i].dataset.mobsrc;
			} else {
				src = (vids[i].dataset.src === undefined) ? vids[i].src : vids[i].dataset.src;
			}
			srcset = vids[i].getAttribute("data-srcset") ? vids[i].getAttribute("data-srcset") : "";
			if (src != null && src != "") {
				vids[i].src = src;
			}
			if (srcset != null && srcset != "") {
				vids[i].srcset = srcset;
			}
			vids[i].classList.remove("lazy2");
	}
}

function lazyLoadImg2() {
	var imgs = document.querySelectorAll("img.lazy3");

	for (i = 0; i < imgs.length; i++) {
		var elemRect = imgs[i].getBoundingClientRect();
        if (elemRect.top != 0 && elemRect.top - wnw_windowHeight < 0) {
			if (wnw_windowWidth < 600) {
				src = (imgs[i].dataset.mobsrc === undefined) ? imgs[i].dataset.src : imgs[i].dataset.mobsrc;
			} else {
				src = (imgs[i].dataset.src === undefined) ? imgs[i].src : imgs[i].dataset.src;
			}
			srcset = imgs[i].getAttribute("data-srcset") ? imgs[i].getAttribute("data-srcset") : "";
			if (src != null && src != "") {
				imgs[i].src = src;
			}
			if (srcset != null && srcset != "") {
				imgs[i].srcset = srcset;
			}
			imgs[i].classList.remove("lazy3");
		}
	}
}

function lazyLoadVideo2() {
	var vids = document.querySelectorAll("video.lazy3");

	for (i = 0; i < vids.length; i++) {
		var elemRect = vids[i].getBoundingClientRect();
        if (elemRect.top != 0 && elemRect.top - wnw_windowHeight < 0) {
			if (wnw_windowWidth < 600) {
				src = (vids[i].dataset.mobsrc === undefined) ? vids[i].dataset.src : vids[i].dataset.mobsrc;
			} else {
				src = (vids[i].dataset.src === undefined) ? vids[i].src : vids[i].dataset.src;
			}
			srcset = vids[i].getAttribute("data-srcset") ? vids[i].getAttribute("data-srcset") : "";
			if (src != null && src != "") {
				vids[i].src = src;
			}
			if (srcset != null && srcset != "") {
				vids[i].srcset = srcset;
			}
			vids[i].classList.remove("lazy3");
		}
	}
}
